.summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-2xl);
}

.score {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-4xl);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.scored {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.actions {
  display: flex;
  gap: var(--tuna-spacing-2);
  align-items: center;
}

.level {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}
